import { Component } from '@angular/core';
import { ShiftService } from '../../../Model/Shift/shift.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { pipe } from 'rxjs';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ShiftMasterPolicyComponent } from '../shift-master-policy/shift-master-policy.component';

@Component({
  selector: 'app-shift-form',
  standalone: true,
  imports: [CommonModule, FormsModule, JsonPipe, NgbTimepickerModule, NgbTooltip, NgSelectModule],
  templateUrl: './shift-form.component.html',
  styleUrl: './shift-form.component.scss'
})
export class ShiftFormComponent {
  isDisabled: boolean = false;
  ShiftGroup: any[] = [];
  ShiftDetail = {
    SelectType: 'insert',
    ShiftMasterid: 0,
    ShiftCode: null,
    ShiftTitle: null,
    InTime: null as any,
    InTimeObj: null as any,
    OutTime: null as any,
    OutTimeObj: null as any,
    DefaultShift: false,
    RotationalShift: false,
    ESS_ShiftGroupMasterID: null,
    AttendanceType: null,
    Duration: null as any,
    DurationObj: null as any,
    HalfDayDuration: null as any,
    HalfDayDurationObj: null as any,
    IsGraceApplicable: false,
    FirstCheckInLateApplicable: false,
    FirstCheckInLate: null as any,
    FirstCheckInLateObj: null,
    LastCheckOutEarlyApplicable: false,
    LastCheckOutEarly: null as any,
    LastCheckOutEarlyObj: null,
    ShiftMargin: false,
    HourBeforeShiftStartApplicable: false,
    HourBeforeShiftStart: null as any,
    HourBeforeShiftStartObj: null,
    HourAfterShiftStartApplicable: false,
    HourAfterShiftStart: null as any,
    HourAfterShiftStartObj: null,
    HourAfterShiftEndApplicable: false,
    HourAfterShiftEnd: null as any,
    HourAfterShiftEndObj: null,
    IsSinglePunchAllowed: false,
  }

  constructor(
    private shift: ShiftService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toast: ToastService,
    private router: Router,
    protected tooltip: TooltipService,
    protected common: CommonService,
    private combo: ComboService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.ShiftDetail.ShiftMasterid = parseInt(params['id']));
  }

  ngOnInit(): void {
    if (this.ShiftDetail.ShiftMasterid > 0) {
      this.LoadShiftMaster();
    }
    this.ComboLoad('ShiftGroup');
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.ShiftDetail.InTimeObj.hour != this.ShiftDetail.OutTimeObj.hour || this.ShiftDetail.InTimeObj.minute != this.ShiftDetail.OutTimeObj.minute) {
        if (this.ShiftDetail.InTimeObj != this.ShiftDetail.OutTimeObj) {
          if (this.ShiftDetail.RotationalShift) {
            if (this.ShiftDetail.InTimeObj != null && this.ShiftDetail.OutTimeObj != null) {
              this.ShiftDetail.InTime = this.ShiftDetail.InTimeObj.hour.toString().padStart(2, '0') + ':' + this.ShiftDetail.InTimeObj.minute.toString().padStart(2, '0');
              this.ShiftDetail.OutTime = this.ShiftDetail.OutTimeObj.hour.toString().padStart(2, '0') + ':' + this.ShiftDetail.OutTimeObj.minute.toString().padStart(2, '0');
              this.ShiftMasterInsertUpdate();
            }
          } else {
            if (this.ShiftDetail.OutTimeObj.hour >= this.ShiftDetail.InTimeObj.hour || (this.ShiftDetail.OutTimeObj.hour == this.ShiftDetail.InTimeObj.hour && this.ShiftDetail.OutTimeObj.minute >= this.ShiftDetail.InTimeObj.minute)) {
              if (this.ShiftDetail.InTimeObj != null && this.ShiftDetail.OutTimeObj != null) {
                this.ShiftDetail.InTime = this.ShiftDetail.InTimeObj.hour.toString().padStart(2, '0') + ':' + this.ShiftDetail.InTimeObj.minute.toString().padStart(2, '0');
                this.ShiftDetail.OutTime = this.ShiftDetail.OutTimeObj.hour.toString().padStart(2, '0') + ':' + this.ShiftDetail.OutTimeObj.minute.toString().padStart(2, '0');
                this.ShiftMasterInsertUpdate();
              }
            } else {
              this.toast.show({ message: 'To time should be greater than from time', type: toastTypeEnum.warning });
            }
          }
        } else {
          this.toast.show({ message: 'Same value not allow in from time and to time', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: 'Please enter from time and to time', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  LoadShiftMaster() {
    this.isDisabled = true;
    this.shift.LoadShiftMaster({ SelectType: 1, ShiftMasterid: this.ShiftDetail.ShiftMasterid }).subscribe({
      next: (response) => {
        this.ShiftDetail = response[0];
        this.ShiftDetail.InTimeObj = { hour: parseInt(this.ShiftDetail.InTime.split(":")[0]), minute: parseInt(this.ShiftDetail.InTime.split(":")[1]) };
        this.ShiftDetail.OutTimeObj = { hour: parseInt(this.ShiftDetail.OutTime.split(":")[0]), minute: parseInt(this.ShiftDetail.OutTime.split(":")[1]) };
        this.ShiftDetail.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ShiftMasterInsertUpdate() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if ((this.common.PageRight.IsAdd && this.ShiftDetail.ShiftMasterid == 0) || (this.common.PageRight.IsEdit && this.ShiftDetail.ShiftMasterid > 0)) {
        if (result) {
          this.isDisabled = true;
          this.shift.ShiftMasterInsertUpdate(this.ShiftDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '01') {
                this.close();
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  timeFormate(event: any, type: String) {
    if (type == 'FromTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftDetail.InTimeObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftDetail.InTimeObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'ToTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftDetail.OutTimeObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftDetail.OutTimeObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

  close() {
    this.router.navigate(['master/shift']);
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': 0,
      'DesignationId': 0,
      'EmpType': null,
      'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {

        if (Combotype == 'ShiftGroup') {
          this.ShiftGroup = response.ComboLoad;
          console.log(this.ShiftGroup);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ShiftMasterPolicy() {
    if (this.common.CompanyParameterValue.IsShiftRuleFromShiftMaster) {
      const modalRef = this.modalService.open(ShiftMasterPolicyComponent, {
        size: 'xl',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.ShiftRuleDetailInput = {
        AttendanceType: this.ShiftDetail.AttendanceType,
        Duration: this.ShiftDetail.Duration,
        DurationObj: (this.ShiftDetail.Duration != null && this.ShiftDetail.Duration != '') ? { hour: parseInt(this.ShiftDetail.Duration.split(':')[0]), minute: parseInt(this.ShiftDetail.Duration.split(':')[1]) } : null,
        HalfDayDuration: this.ShiftDetail.HalfDayDuration,
        HalfDayDurationObj: (this.ShiftDetail.HalfDayDuration != null && this.ShiftDetail.HalfDayDuration != '') ? { hour: parseInt(this.ShiftDetail.HalfDayDuration.split(':')[0]), minute: parseInt(this.ShiftDetail.HalfDayDuration.split(':')[1]) } : null,
        IsGraceApplicable: this.ShiftDetail.IsGraceApplicable,
        FirstCheckInLateApplicable: this.ShiftDetail.FirstCheckInLateApplicable,
        FirstCheckInLate: this.ShiftDetail.FirstCheckInLate,
        FirstCheckInLateObj: (this.ShiftDetail.FirstCheckInLate != null && this.ShiftDetail.FirstCheckInLate != '') ? { hour: parseInt(this.ShiftDetail.FirstCheckInLate.split(':')[0]), minute: parseInt(this.ShiftDetail.FirstCheckInLate.split(':')[1]) } : null,
        LastCheckOutEarlyApplicable: this.ShiftDetail.LastCheckOutEarlyApplicable,
        LastCheckOutEarly: this.ShiftDetail.LastCheckOutEarly,
        LastCheckOutEarlyObj: (this.ShiftDetail.LastCheckOutEarly != null && this.ShiftDetail.LastCheckOutEarly != '') ? { hour: parseInt(this.ShiftDetail.LastCheckOutEarly.split(':')[0]), minute: parseInt(this.ShiftDetail.LastCheckOutEarly.split(':')[1]) } : null,
        ShiftMargin: this.ShiftDetail.ShiftMargin,
        HourBeforeShiftStartApplicable: this.ShiftDetail.HourBeforeShiftStartApplicable,
        HourBeforeShiftStart: this.ShiftDetail.HourBeforeShiftStart,
        HourBeforeShiftStartObj: (this.ShiftDetail.HourBeforeShiftStart != null && this.ShiftDetail.HourBeforeShiftStart != '') ? { hour: parseInt(this.ShiftDetail.HourBeforeShiftStart.split(':')[0]), minute: parseInt(this.ShiftDetail.HourBeforeShiftStart.split(':')[1]) } : null,
        HourAfterShiftStartApplicable: this.ShiftDetail.HourAfterShiftStartApplicable,
        HourAfterShiftStart: this.ShiftDetail.HourAfterShiftStart,
        HourAfterShiftStartObj: (this.ShiftDetail.HourAfterShiftStart != null && this.ShiftDetail.HourAfterShiftStart != '') ? { hour: parseInt(this.ShiftDetail.HourAfterShiftStart.split(':')[0]), minute: parseInt(this.ShiftDetail.HourAfterShiftStart.split(':')[1]) } : null,
        HourAfterShiftEndApplicable: this.ShiftDetail.HourAfterShiftEndApplicable,
        HourAfterShiftEnd: this.ShiftDetail.HourAfterShiftEnd,
        HourAfterShiftEndObj: (this.ShiftDetail.HourAfterShiftEnd != null && this.ShiftDetail.HourAfterShiftEnd != '') ? { hour: parseInt(this.ShiftDetail.HourAfterShiftEnd.split(':')[0]), minute: parseInt(this.ShiftDetail.HourAfterShiftEnd.split(':')[1]) } : null,
        IsSinglePunchAllowed: this.ShiftDetail.IsSinglePunchAllowed,
      };

      modalRef.result.then((result: any) => {
        if (result) {
          if (result != undefined) {
            this.ShiftDetail.AttendanceType = result.AttendanceType;
            this.ShiftDetail.Duration = result.Duration;
            this.ShiftDetail.HalfDayDuration = result.HalfDayDuration;
            this.ShiftDetail.IsGraceApplicable = result.IsGraceApplicable;
            this.ShiftDetail.FirstCheckInLateApplicable = result.FirstCheckInLateApplicable;
            this.ShiftDetail.FirstCheckInLate = result.FirstCheckInLate;
            this.ShiftDetail.LastCheckOutEarlyApplicable = result.LastCheckOutEarlyApplicable;
            this.ShiftDetail.LastCheckOutEarly = result.LastCheckOutEarly;
            this.ShiftDetail.ShiftMargin = result.ShiftMargin;
            this.ShiftDetail.HourBeforeShiftStartApplicable = result.HourBeforeShiftStartApplicable;
            this.ShiftDetail.HourBeforeShiftStart = result.HourBeforeShiftStart;
            this.ShiftDetail.HourAfterShiftStartApplicable = result.HourAfterShiftStartApplicable;
            this.ShiftDetail.HourAfterShiftStart = result.HourAfterShiftStart;
            this.ShiftDetail.HourAfterShiftEndApplicable = result.HourAfterShiftEndApplicable;
            this.ShiftDetail.HourAfterShiftEnd = result.HourAfterShiftEnd;
            this.ShiftDetail.IsSinglePunchAllowed = result.IsSinglePunchAllowed;
          }
        }
      }).catch(() => {
        // Modal dismissed
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
} 
